import React, { useState, FormEvent } from 'react';
import { IoSend } from 'react-icons/io5';
import * as S from './styles';
import ButtonIcon from '../../newStudent/Buttons/ButtonIcon';

interface IMessageInputProps {
  onSendMessage: (content: string) => Promise<boolean>;
  disabled?: boolean;
}

export default function MessageInput({ onSendMessage, disabled = false }: IMessageInputProps) {
  const [message, setMessage] = useState('');

  const handleSubmit = async (e: FormEvent) => {
    e.preventDefault();
    if (!message.trim() || disabled) return;

    const messageToSend = message.trim();
    setMessage('');
    
    onSendMessage(messageToSend).catch(() => {
      // Erro ao enviar mensagem
    });
  };

  return (
    <S.Container onSubmit={handleSubmit}>
      <S.Input
        value={message}
        onChange={(e) => setMessage(e.target.value)}
        placeholder="Digite sua mensagem..."
        disabled={disabled}
        onKeyDown={(e) => {
          if (e.key === 'Enter' && !e.shiftKey) {
            e.preventDefault();
            handleSubmit(e);
          }
        }}
      />
      <ButtonIcon type="submit" color="primary" widthSize="xxsmall" heightSize="small" disabled={!message.trim() || disabled} icon={<IoSend size={16} />}/>
    </S.Container>
  );
}

